import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoaderService } from 'src/app/common/loader.service';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-country',
  templateUrl: './add-country.component.html',
  styleUrls: ['./add-country.component.scss']
})
export class AddCountryComponent implements OnInit {

  addCountryTitle = true;
  editCountryTitle;
  countryform: FormGroup;
  submitted = false;
  constructor(private formBuilder: FormBuilder,private masterService: MasterService,private loaderService:LoaderService,private toasterService: ToastrService) {this.getFromGroup(); }

  ngOnInit() {
  }
  get f() { return this.countryform.controls; }
  private getFromGroup() {
    this.countryform = this.formBuilder.group({
      'cotryCodeInternational':new FormControl(),
      'cotryCodeLocal': new FormControl(),
      'cotryCode': new FormControl(),
      'cotryDescEn': new FormControl(),
      'cotryDesc': new FormControl(),
      'cotryVaNationalityEn': new FormControl(),
      'contiCode': new FormControl(),
      'ctareCode': new FormControl()
    })
  }
  saveCountry(){
    /* this.submitted = true;
    if (this.logisticsForm.invalid) {
      return;
    } */
    let saveData = this.countryform.value;
    this.loaderService.display(true);
    this.masterService.saveCountry(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"]==0) {
        this.countryform.patchValue({cotryId: response['result']});
        this.toasterService.success(response['message'], 'Success');
      }else{
        this.toasterService.error(response['message'], 'Error');
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  }
